export default __webpack_public_path__ + "static/media/9d6498e8849765a40ac3a4ac810555d01576601597917.1fbefda2.webp";